export const isNotNullOrUndefined = function (input) {
	return input !== null && input !== undefined;
};
